// angular dependencies
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: `fz-game-card-time, [fz-game-card-time], [fzGameCardTime]`,
  templateUrl: './card-time.component.html',
  styleUrls: ['./card-time.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GameCardTimeComponent {
  _start!: Date;
  _end!: Date;

  @Input()
  set start(value: Date | string | null | undefined) {
    if (value) {
      this._start = typeof value == 'string' ? new Date(value) : value;
    }
  }

  get start(): Date {
    return this._start;
  }

  @Input()
  set end(value: Date | string | null | undefined) {
    if (value) {
      this._end = typeof value == 'string' ? new Date(value) : value;
    }
  }

  get end(): Date {
    return this._end;
  }
}
